import React from 'react';
import _ from 'lodash';

import {
  BaseWidget,
  activityTemplates
} from 'modules';
import {
  LoadingOverlay,
  Table,
  modalUtil
} from 'iron-forge-react-modules';

import { Button } from '@mui/material';
import * as SaveThirdPartyAccountModal from './SaveThirdPartyAccountModal/SaveThirdPartyAccountModal';
import * as dataService from './dataService';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export const ThirdPartyAccountActivity: React.FC = () => {
  const {
    modalType2TargetId,
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers(['saveThirdPartyAccount']);
  const {
    queryTuple,
    pageInfo,
    fnQueryPage
  } = dataService.useQuery();



  const handleClickAddAccount = React.useCallback(
    () => {
      setModalIsOpen('saveThirdPartyAccount', true);
    },
    [setModalIsOpen]
  );

  const handleClickRowPopoverOption = React.useCallback(
    (rowId: string, optionId: string) => {
      if (optionId === 'edit') {
        setModalIsOpen('saveThirdPartyAccount', rowId);
      }
    },
    [setModalIsOpen]
  );



  const rows = React.useMemo(
    () => _.map(queryTuple.data.accounts, (account): types.IRow => ({
      id: account.id,
      columnId2Value: {
        name: {
          type: 'string',
          label: account.name
        },
        accountNumber: {
          type: 'string',
          label: account.accountNumber
        },
        carrierType: {
          type: 'string',
          label: account.carrierType
        },
        address: {
          type: 'string',
          label: account.address
        },
        addressee: {
          type: 'string',
          label: account.addressee
        },
        attention: {
          type: 'string',
          label: account.attention
        }
      },
      popoverOptions: [
        {
          id: 'edit',
          label: "Edit"
        }
      ]
    })),
    [queryTuple]
  );

  return (
    <>
      <activityTemplates.AdminActivityTemplate.FC>
        <LoadingOverlay.FC active={queryTuple.loading} />

        <BaseWidget.FC elAction={(
          <Button
            variant="contained"
            onClick={handleClickAddAccount}>
            Add Account
          </Button>
        )}>
          <TableComponent
            rows={rows}
            disableSorting
            paginationOptions={Table.pageInfo2PaginationOptions(pageInfo, fnQueryPage)}
            columns={[
              {
                id: 'name',
                label: "Name"
              },
              {
                id: 'accountNumber',
                label: "Account #"
              },
              {
                id: 'carrierType',
                label: "Carrier Type"
              },
              {
                id: 'attention',
                label: "Attention"
              },
              {
                id: 'addressee',
                label: "Addressee"
              },
              {
                id: 'address',
                label: "Address"
              }
            ]}
            onClickRowPopoverOption={handleClickRowPopoverOption} />
        </BaseWidget.FC>
      </activityTemplates.AdminActivityTemplate.FC>


      {(modalType2TargetId.saveThirdPartyAccount || modalType2IsOpen.saveThirdPartyAccount) && (
        <SaveThirdPartyAccountModal.FC
          accountId={modalType2TargetId.saveThirdPartyAccount}
          onClose={() => setModalIsOpen('saveThirdPartyAccount', false)}
          onSave={() => {
            setModalIsOpen('saveThirdPartyAccount', false);
            if (queryTuple.refetch) {
              queryTuple.refetch();
            }
          }} />
      )}
    </>
  );
};
